import {
  DailyRevenueComparison,
  DashboardFilterArgs,
  DashboardSummary,
} from '../models/dashboard';

import {api} from './api';

const buildDashboardParams = (args: DashboardFilterArgs): URLSearchParams => {
  const params = new URLSearchParams();

  if (args.iserId) {
    params.append('iserId', args.iserId);
  }

  if (args.startDate) {
    params.append('startDate', args.startDate);
  }

  if (args.endDate) {
    params.append('endDate', args.endDate);
  }

  if (args.branchIds?.length) {
    args.branchIds.forEach((id) => params.append('branchIds', id));
  }

  if (args.stationIds?.length) {
    args.stationIds.forEach((id) => params.append('stationIds', id));
  }

  return params;
};

export const dashboard = api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardSummary: builder.query<DashboardSummary, DashboardFilterArgs>({
      query: (args) => ({
        url: `reports/summary?${buildDashboardParams(args).toString()}`,
        method: 'get',
      }),
      providesTags: () => ['Dashboard'],
    }),
    getDailyRevenueComparison: builder.query<
      DailyRevenueComparison,
      DashboardFilterArgs
    >({
      query: (args) => ({
        url: `reports/daily-revenue-comparison?${buildDashboardParams(
          args,
        ).toString()}`,
        method: 'get',
      }),
      providesTags: () => ['Dashboard'],
    }),
  }),
});

export const {
  useGetDashboardSummaryQuery,
  useGetDailyRevenueComparisonQuery,
} = dashboard;
